
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator';
@Component
class EmailBrandingDrawer extends Vue {
  @Prop() private drawerWidth!: string;
}
export default toNative(EmailBrandingDrawer);
